import { render, staticRenderFns } from "./Vaccinare.vue?vue&type=template&id=1785b181&scoped=true&"
import script from "./Vaccinare.vue?vue&type=script&lang=js&"
export * from "./Vaccinare.vue?vue&type=script&lang=js&"
import style0 from "./Vaccinare.vue?vue&type=style&index=0&id=1785b181&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1785b181",
  null
  
)

export default component.exports